export enum DeviceSource {
  Browser = 'Browser',
  UserAgentString = 'UserAgentString'
}
